import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../../services/api'
import { Box, CREToolTab, IconButton, Text, Map, HelperButton, IndustrialCard, Card } from '../../components'
import { NextButton, PrevButton } from '../../components/Button'
import { IndustrialCompaniesLogos } from '../../components/industrial/IndustrialCompaniesLogos'
import theme from '../../theme'
import { Grid } from '@mui/material'
import { IndustrialTransactionGrid } from '../../components/industrial/IndustrialTransactionGrid'
import { IndustrialSimilarBuildingCard } from '../../components/industrial/IndustrialSimilarBuildingCard'
import { BarChartOccupationHistoryIndustrial } from '../../components/industrial/BarChartOccupationHistoryIndustrial'
import { PieChartOccupationIndustrial } from '../../components/industrial/PieChartOccupation'

import classeIcon from '../../../assets/icons/classe_buildings.svg'
import perfilIcon from '../../../assets/icons/perfil.svg'
import dataEntregaIcon from '../../../assets/icons/data_entrega.svg'
import statusIcon from '../../../assets/icons/check.svg'
import areaLocavelTotalIcon from '../../../assets/icons/area_locavel_total.svg'
import areaDispIcon from '../../../assets/icons/area_disp.svg'
import vacanciaIcon from '../../../assets/icons/vacancia.svg'
import AbsorvicaoIcon from '../../../assets/icons/absorvisao_liquida.svg'
import { EvaluationCardIndustrial } from '../../components/industrial/evaluation/EvaluationCardIndustrial'
import { useApp } from '../../../contexts'
import { getCoinCountryLabel, getImageLabel, translateText } from '../../../helpers/util'

const Dashboard = () => {
    const { industrialId, accessToken } = useParams()
    const [industrial, setIndustrial] = useState({})
    const [permissions, setPermissions] = useState([])
    const [markers, setMarkers] = useState([])
    const { setBuildingCountry } = useApp()

    useEffect(() => {
        getPermissions();
        loadIndustrialData();
    }, []);

    useEffect(() => {
        prepareMarkers(industrial)
    }, [industrial]);

    const loadIndustrialData = async () => {
        const config = {}
        if (accessToken !== "") {
            config.headers = {
                'Authorization': 'Bearer ' + accessToken
            }
        }

        const response = await api.get(`/industrial/${industrialId}/dashboard`, config)
        const { data: industrialData } = response

        Promise.all([response]).then((values) => {
            setBuildingCountry(industrialData.specs.pais)
            setIndustrial(industrialData)
            prepareMarkers(industrialData)
        }).catch(err => {
            console.log(err)
        });
    }

    const getPermissions = async () => {
        const params = { permissions: "transacao,menuEstatistica" }
        const config = {}
        if (accessToken !== "") {
            config.headers = {
                'Authorization': 'Bearer ' + accessToken,
                "Content-Type": "application/json"
            }
        }
        const response = await api.post(`/user/permission`, params, config)
        const { data: permi } = response
        Promise.all([response]).then((values) => {
            setPermissions(permi.data)
        }).catch(err => {
            console.log(err)
        });
    }

    const prepareMarkers = (industrial) => {

        const { specs, similarBuildings } = industrial

        if (!specs) return
        // console.log(similarBuildings);

        const similarBuildingsMarkers = similarBuildings.map((building, index) => {
            return { lat: building.lat, lng: building.log, html: building.nome, markerType: 'point', number: index + 1 }
        })

        let marker = [...markers, { lat: specs.lat, lng: specs.log, html: specs.nome }, ...similarBuildingsMarkers]
        setMarkers(marker)
    }

    return (
        <CREToolTab>
            <Layout industrial={industrial} markers={markers} permissions={permissions} />
        </CREToolTab>
    )
}

const getNumberWithDecimal = (number) => {
    if(number !== null && number !== undefined){
        return Intl.NumberFormat().format(parseFloat(number).toFixed(1))
    }
    return "-"
}

const Layout = ({ industrial, markers, permissions }) => {
    
    const [activeSimilarBuilding, setActiveSimilarBuilding] = useState(0)
    const { specs, images = [], similarBuildings = [] } = industrial
    const [vmvi, setVmvi] = useState(null)
    const handleVMVI = (newValue) => {
        setVmvi(newValue)
    }
    const { language, translations, userCountry, buildingCountry } = useApp()

    return (
        <Box sx={{ flexGrow: 1 }}>
            {specs &&
                <>
                    <Grid container spacing={1}>
                        {specs &&
                            <IndustrialHeader specs={specs} />
                        }
                        {/* Esquerda da Dashboard */}
                        <Grid item xs={4}>
                            <IndustrialImages images={images} />
                            {specs && <IndustrialAddress specs={specs} />}
                            <Box sx={{ flexDirection: 'column', display: 'flex', marginBottom: 1, marginTop: 1 }}>
                                <Card>
                                    <Map
                                        fitBounds={false}
                                        zoom={14}
                                        markers={markers}
                                        center={{ lat: specs.lat, lng: specs.log }}
                                    />
                                    <Text style={{ fontSize: 14, color: "#7a7b7c", marginLeft: 5, fontWeight: "600" }}>
                                        {translateText("Imóveis Semelhantes", language, translations, userCountry)}
                                    </Text>
                                    <div style={{ flexDirection: 'row', display: 'flex', padding: 1, position: 'relative', marginTop: 4, marginBottom: 4 }}>
                                        <div style={{ position: 'absolute', left: 0, top: '25%', zIndex: "1" }}>
                                            {activeSimilarBuilding > 0 &&
                                                <PrevButton onClick={() => {
                                                    setActiveSimilarBuilding(activeSimilarBuilding - 1)
                                                }} />
                                            }
                                        </div>
                                        {similarBuildings.map((building, index) => {
                                            return <IndustrialSimilarBuildingCard key={`similarBuilding_${index}`} building={building} index={index + 1} />
                                        }).filter((building, index) => index >= activeSimilarBuilding)}
                                        <div style={{ position: 'absolute', right: 0, top: '25%', zIndex: "1" }}>
                                            {activeSimilarBuilding < similarBuildings.length - 1 &&
                                                <NextButton onClick={() => {
                                                    setActiveSimilarBuilding(activeSimilarBuilding + 1)
                                                }} />
                                            }
                                        </div>
                                    </div>
                                </Card>
                            </Box>
                        </Grid>
                        {/* Direita da Dashboard */}
                        <Grid item sx={{ flexGrow: 0 }} alignItems="flex-start" xs={8}>
                            
                            <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', marginBottom: 1 }}>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={vacanciaIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>
                                                {getNumberWithDecimal(specs.taxa_vacancia)}
                                            </Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Taxa de Vacância", language, translations, userCountry)} (%)</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={dataEntregaIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{specs.status == "Em Projeto" ? "-" : specs.data_entrega}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Ano de entrega", language, translations, userCountry)}</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={areaLocavelTotalIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(specs.area_locavel_total)}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Área Locável Total", language, translations, userCountry)} (m²)</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={classeIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{specs.classe_imovel}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Classe Buildings", language, translations, userCountry)}</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                            </Box>

                            <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', marginBottom: 1 }}>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={AbsorvicaoIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(specs.absorcao_liquida)}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Absorção Líquida", language, translations, userCountry)} (m²)</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={statusIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 14, fontWeight: '700', color: '#464648' }}>{ translateText(specs.status, language, translations, userCountry)}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Status", language, translations, userCountry)}</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={areaDispIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{Intl.NumberFormat().format(specs.area_locavel_disponivel)}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Área Disponível", language, translations, userCountry)} (m²)</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                                <Grid item xs={3}>
                                    <IndustrialCard>
                                        <Box sx={styles.boxImage}>
                                            <img src={perfilIcon} width={24} height={24} />
                                            <Text style={{ fontSize: 16, fontWeight: '700', color: '#464648' }}>{translateText(specs.tipo_imovel, language, translations, userCountry)}</Text>
                                        </Box>
                                        <Box>
                                            <Text style={{ fontSize: 11 }}>{translateText("Tipo Imóvel", language, translations, userCountry)}</Text>
                                        </Box>
                                    </IndustrialCard>
                                </Grid>
                            </Box>

                            {
                                (permissions.includes("transacao")) && (
                                    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', marginBottom: 1 }}>
                                        <EvaluationCardIndustrial handleVMVI={handleVMVI} industrialId={specs.id_imovel} />
                                    </Box>
                                )
                            }

                            <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', marginBottom: 1 }}>
                                <IndustrialCard>
                                    <PieChartOccupationIndustrial industrialId={specs.id_imovel} />
                                </IndustrialCard>
                                {
                                    (permissions.includes("menuEstatistica")) && (
                                        <IndustrialCard>
                                            <BarChartOccupationHistoryIndustrial industrialId={specs.id_imovel} />
                                        </IndustrialCard>
                                    )
                                }
                            </Box>
                            
                            <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', marginBottom: 1 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <IndustrialCard sx={{ marginBottom: 1, overflow: 'inherit' }}>
                                        <IndustrialCompaniesLogos industrialId={specs.id_imovel} />
                                    </IndustrialCard>
                                    <IndustrialCard sx={{ overflow: 'inherit' }}>
                                        <IndustrialCompaniesLogos industrialId={specs.id_imovel} type={'owners'} />
                                    </IndustrialCard>
                                </Box>
                                {
                                    (permissions.includes("transacao")) && (
                                        <Box sx={{ display: 'flex', flex: 1, width: "50%", maxHeight: 300 }}>
                                            <IndustrialCard>
                                                <IndustrialTransactionGrid industrialId={specs.id_imovel} vmvi={vmvi} />
                                            </IndustrialCard>
                                        </Box>
                                    )
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </>
            }
        </Box>
    )
}

const IndustrialHeader = ({ specs }) => {
    return <Grid item xs={12}>
        <div style={{ paddingLeft: 10, flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: '600', color: theme.palette.primary.main, marginBottom: 10 }}>
                {specs.nome_imovel}
            </div>
        </div>
    </Grid>
}

const IndustrialImages = ({ images }) => {

    const [imgIndex, setImgIndex] = useState(0)
    const { language, translations, userCountry } = useApp()

    return <div style={{ position: 'relative', borderRadius: 4, width: "100%", height: 450 }}>
        {images.length > 0 &&
            <>
                <img src={`https://d6bmyxfy7viyd.cloudfront.net/${images[imgIndex]?.url}`} height='450' style={{ width: "100%", borderRadius: 4, objectFit: 'cover' }} />
                <div style={{ backgroundColor: '#32587D', height: 50, width: '100%', position: 'absolute', bottom: 0, zIndex: 10, opacity: 0.8, borderBottomRightRadius: 4, borderBottomLeftRadius: 4 }}>
                </div>
                <div style={{ height: 50, width: '100%', position: 'absolute', bottom: 0, zIndex: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <PrevButton onClick={() => setImgIndex(imgIndex > 0 ? imgIndex - 1 : 0)} />
                    <div style={{ color: '#FFF', flex: 1, justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 14 }}>
                        {getImageLabel(images[imgIndex].descricao, language, translations, userCountry)}
                    </div>
                    <NextButton onClick={() => setImgIndex(imgIndex < images.length - 1 ? imgIndex + 1 : 0)} />
                </div>
            </>
        }
    </div>
}

const IndustrialAddress = ({ specs }) => {
    const { language, translations, userCountry } = useApp()
    return <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: 1 }}>
        <IndustrialCard sx={{ marginRight: 0 }}>
            <span style={{ fontSize: 14 }}>
                <div>{specs.endereco}, {specs.numero}</div>
                <div>{specs.pais !== "Chile" ? translateText("Região Buildings", language, translations, userCountry) + ": " : "Submercado" + ": "} {specs.regiao_buildings}</div>
                <div>{specs.cidade} - {specs.uf}</div>
            </span>

        </IndustrialCard>
    </Box>
}

const styles = {
    boxImage: {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
}

export default Dashboard